import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MailCheckout } from 'src/app/models/mail-checkout';
import { PermiteReenvioSolicitacao } from 'src/app/models/PermiteReenvioSolicitacao.model';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';
import { StateService } from 'src/app/state/state.service';
import { PreCheckoutViagemService, Values } from '../pre-checkout-viagem.service';

@Component({
  selector: 'app-pre-checkout-viagem-send-mail',
  templateUrl: './pre-checkout-viagem-send-mail.component.html',
  styleUrls: ['./pre-checkout-viagem-send-mail.component.css']
})
export class PreCheckoutViagemSendMailComponent implements OnInit {

  tiposTransporte: Array<any> = [];
  transportadoras: Array<any> = [];
  itemSelected: any = {id:0, name:""};
  itemSelectedTransportadora: any = {id:0, name:""};
  tentativa: number = 0;
  translation: any;
  info: string;
  labelInfo: string = null;
  showPlacas: boolean = false;
  showInfo: boolean = true;
  wait: boolean = false;
  scheduler: any;
  values: Values = new Values();
  placas: any[] = [
    {placa:"", tipo:"", validar: true},
    {placa:"", tipo:"", validar: false},
    {placa:"", tipo:"", validar: false}
  ];
  cpf: string;
  nome: string;
  celular: string;
  rota: string;
  cdOrigemDescricao: string;
  complementoEmail: string = null;
  recipientMail: string = null;
  titleMail: string = null;
  mailCheckout: MailCheckout = new MailCheckout();

  cdsDestino: Array<any> = [];
  itemSelectedDestino: any = {id:0, name:""};

  constructor(
    private preCheckoutService: PreCheckoutService,
    private translate: TranslateService,
    private stateService: StateService,
    private alertService: AlertService,
    private preCheckoutQuery: PreCheckoutQuery,
    private spinnerService: SpinnerService,
    private router: Router,
    private viagemService: PreCheckoutViagemService
  ) { }

  exibeLabel(obj: any){
    if(obj.id==1)
      this.labelInfo = null;
    else if(obj.id==2)
      this.labelInfo = "Informe os dados da ordem de coleta";
    else if(obj.id==3)
      this.labelInfo = "Informe os dados da Nota Fiscal/Lacre";
    else if(obj.id==4)
      this.labelInfo = "Informe o número do CTD";
  }

  selectEvent(obj: any)
  {
    this.exibeLabel(obj);
  }

  onInputCleared()
  {
    this.labelInfo = null;
  }

  populaCdsDestino(descricao: string = null){
    this.preCheckoutService.getCds(true, descricao)
    .subscribe(
      (result) => {
        if(result)
        {
          this.cdsDestino = [];
          
          for(let cd of result.content)
          {
            let obj = {id:cd.id,name:cd.descricao};
            this.cdsDestino.push(obj);
          }
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar recuperar CDs de destino, tente novamente!");
      }
    );
  }

  onChangeSearch(descricao: string)
  {
    this.populaCdsDestino(descricao);
  }

  onChangeSearchTransportadora(cnpj: string)
  {
    if(cnpj.trim().length>5)
      this.populaTransportadoras(cnpj);
  }

  populaTransportadoras(cnpj: string = null){
    this.preCheckoutService.getTranspotadoras(cnpj)
    .subscribe(
      (result) => {
        if(result)
        {
          this.transportadoras = [];
          
          for(let transp of result?.content[0]?.embarcadores_transportadores)
          {
            let obj = {id:transp.codigo,name:transp.cnpj + "-" + transp.razao_social};
            this.transportadoras.push(obj);
          }
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar recuperar transportadoras, tente novamente!");
      }
    );
  }

  limpaPlacas(){
    this.placas = [
      {placa:"", tipo:"", validar: true},
      {placa:"", tipo:"", validar: false},
      {placa:"", tipo:"", validar: false}
    ];
  }

  onBlurMotor(veiculo: any)
  {
    this.consultaVeiculo(veiculo.placa, null, function(result){
      veiculo.placa = result.placa;
      veiculo.tipo = result.tipo;

      if(!result.status){
        this.alertService.alertWarning(result.mensagem, null);
        this.placas[0].placa = null;
      }
      else if(result.tipo=="CAVALO"){
        this.placas[1].validar = true;
      }
      else if(result.tipo=="CARRETA"){
        this.alertService.alertWarning("Informe primeiro a placa do CAVALO para depois informar a placa da CARRETA!", null);
        this.placas[0].placa = null;
      }
      else{
        this.alertService.alertSuccess("Placa validada com sucesso, clique em ENVIAR!", null);
      }
    }.bind(this),function(){
      this.alertService.alertWarning("A placa informada não foi localizada, tente novamente", null);
      this.limpaPlacas();
    }.bind(this));
  }

  onBlurCarreta(veiculo: any)
  {
    this.consultaVeiculo(veiculo.placa, "CARRETA", function(result){
      veiculo.placa = result.placa;
      veiculo.tipo = result.tipo;

      if(!result.status){
        this.alertService.alertWarning(result.mensagem, null);
        veiculo.placa = null;
        veiculo.tipo = null;
      }
    }.bind(this),function(){
      this.alertService.alertWarning("A placa informada não é do tipo carreta, tente novamente!", null);
      veiculo.placa = null;
      veiculo.tipo = null;
    }.bind(this));
  }

  consultaVeiculo(placa: string, tipo: string = null, callBack1: any = null, callBack2: any = null){
    if(placa){
      this.preCheckoutService.getVeiculo(placa, this.values.cdOrigem, tipo)
      .subscribe(
        (result) => {
          if(result)
          {
            this.alertService.limpaAlertMessage();
            if(callBack1)
              callBack1(result);
          }
          else{
            if(callBack2)
              callBack2();
          }
        },
        (err) => {
          this.internalError("Ocorreu um erro ao tentar consultar veículo, tente novamente!");
        }
      );
    }
  }

  validaCampos(): boolean{
    if(!this.itemSelected.id)
      return false;
    else if((this.itemSelected.id == 2 || this.itemSelected.id == 3) && !this.itemSelectedDestino.id)
      return false;
    else if(!this.itemSelectedTransportadora.id)
      return false;
    else if(!this.info && this.itemSelected.id>1)
      return false;

    return true;
  }

  validaPlacas(validaTipo: boolean = true): boolean{
    if(!this.placas[0].placa || (!this.placas[0].tipo && validaTipo))
      return false;
    else if(this.placas[0].tipo=="CAVALO" && (!this.placas[1].placa || (!this.placas[1].tipo && validaTipo)))
      return false;
    else if(this.placas[2].validar && (!this.placas[2].placa || (!this.placas[2].tipo && validaTipo)))
      return false;

    return true;
  }

  updatePlacas(){
    //Atualiza somente com as placas ativas
    let plates = this.placas.filter(function (p) {
      return p.validar == true && p.placa;
    });

    this.stateService.updatePlates(plates);
  }
  
  getInfoMail(){
    let complementoTitulo = this.values.rota ? "Rota: " + this.values.rota : "CD: " + this.cdOrigemDescricao.substring(0,4);

    switch(this.itemSelected.id){
      case 1:
        this.recipientMail = "gerenciamentologistico@gpabr.com;vinicius.pereira2@gpabr.com";
        this.titleMail = "[Pré-Checkout] - "+complementoTitulo+" - Solicitação de Geração de SM – Tipo de Transporte: OUTBOUND";
        break;
      case 2:
        this.recipientMail = "coletas.inbound@multivarejogpa.com;vinicius.pereira2@gpabr.com";
        this.titleMail = "[Pré-Checkout] - "+complementoTitulo+" - Solicitação de Geração de SM – Tipo de Transporte: INBOUND";
        this.complementoEmail = "Ordem de Coleta";
        break;
      case 3:
        this.recipientMail = "gerenciamentologistico@gpabr.com;vinicius.pereira2@gpabr.com";
        this.titleMail = "[Pré-Checkout] - "+complementoTitulo+" - Solicitação de Geração de SM – Tipo de Transporte: REVERSA";
        this.complementoEmail = "Nota Fiscal Coleta / Lacre";
        break;
      case 4:
        this.recipientMail = "gerenciamentologistico@gpabr.com;vinicius.pereira2@gpabr.com";
        this.titleMail = "[Pré-Checkout] - "+complementoTitulo+" - Solicitação de Geração de SM – Tipo de Transporte: EED";
        this.complementoEmail = "CTD";
        break;
    }
  }

  getBodyMail(): string{
    let html = "<!DOCTYPE html>";
    html += "<html>";
    html += "<head>";
    html += "<title>Page Title</title>";
    html += "</head>";
    html += "<body style='background-color: #E4E4E4;'>";
    html += "<div style='position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 400px; height: auto; background-color: #ccc; border-radius: 3px; padding: 10px;'>";
    html += "<p><center><strong>&lt;Solicitação encaminhada pelo motorista através do aplicativo Pré-checkout, e-mail automático não responda&gt;</center></strong></p>";
    html += "<br/>";
    html += "<p>Solicitação de geração de SM:</p>";
    html += "<p><strong>Transportadora</strong>: "+this.itemSelectedTransportadora.name+" </p>";
    html += "<p><strong>CPF</strong>: "+this.cpf+" </p>";
    html += "<p><strong>Nome</strong>: "+this.nome+" </p>";
    html += "<p><strong>Celular contato</strong>: "+this.celular+" </p>";
    if(this.placas[0].placa)
      html += "<p><strong>Placa Cavalo</strong>: "+this.placas[0].placa+" </p>";
    if(this.placas[1].placa)
      html += "<p><strong>Placa Carreta</strong>: "+this.placas[1].placa+" </p>";
    if(this.placas[2].placa)
      html += "<p><strong>Placa Carreta</strong>: "+this.placas[2].placa+" </p>";
    html += "<p><strong>Tipo de transporte</strong>: "+this.itemSelected.name+" </p>";
    if(this.rota)
      html += "<p><strong>Rota</strong>: "+this.rota+" </p>";
    html += "<p><strong>CD Orig.</strong>: "+this.cdOrigemDescricao+" </p>";
    if(this.itemSelectedDestino.name)
      html += "<p><strong>CD Destino.</strong>: "+this.itemSelectedDestino.name+" </p>";
    if(this.complementoEmail)
      html += "<p><strong>"+this.complementoEmail+"</strong>: "+this.info+" </p>";
    html += "</div>";
    html += "</body>";
    html += "</html>";

    return html;
  }

  async cadastraEnvioSolicitacao(): Promise<number>{
    this.mailCheckout.cpf = this.cpf;
    this.mailCheckout.cd_origem = this.values.cdOrigem?.toString();
    this.mailCheckout.rota = this.values.rota;
    this.mailCheckout.placa = this.placas[0].placa;
    this.mailCheckout.tipo = 1;

    return await this.preCheckoutService.CreateMailCheckout(this.mailCheckout).toPromise();
  }

  async permiteReenvioSolicitacao(): Promise<PermiteReenvioSolicitacao>{
    this.mailCheckout.cpf = this.cpf;
    this.mailCheckout.cd_origem = this.values.cdOrigem?.toString();
    this.mailCheckout.rota = this.values.rota;
    this.mailCheckout.placa = this.placas[0].placa;
    this.mailCheckout.tipo = 1;

    return await this.preCheckoutService.PermiteReenvioSolicitacao(this.mailCheckout).toPromise();
  }

  loadWait(){
    setTimeout(function(){
      this.spinnerService.requestStarted("ampulheta.gif", "Aguarde...", true, "Já contactado, clique aqui!", true);
    }.bind(this), 500);
  }

  async enviarSolicitacao(){
    let permite = await this.permiteReenvioSolicitacao();

    if(permite.valid){
      this.sendMail();
    }
    else{
      this.loadWait();
      this.updatePlacas();
      this.alertService.alertWarning(`Solicitação de abertura de SM já foi enviada em ${permite.data_cadastro}, favor aguardar o retorno!`, null);
      this.showPlacas = false;
      this.wait = true;
      this.schedulerExisteSM();
    }
  }

  sendMail(){
    this.getInfoMail();
    
    let title = this.titleMail;
    let recipient = this.recipientMail;
    let body = this.getBodyMail();
    
    this.preCheckoutService.sendMail(title, body, recipient)
    .subscribe(
      (result) => {
        if(result)
        {
          this.loadWait();
          this.cadastraEnvioSolicitacao();
          this.updatePlacas();
          this.alertService.alertSuccess("Solicitação de abertura de SM enviada com sucesso!", null);
          this.showPlacas = false;
          this.wait = true;
          this.schedulerExisteSM();
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar enviar e-mail de solicitação de abertura de SM, tente novamente!");
      }
    );
  }

  //Verifica se existe SM cadastrada a cada 5 minutos
  schedulerExisteSM(){
    console.log("setInterval: Consultando SM a cada 5 minutos");
    this.scheduler = setInterval(() => {
      this.existeSM(null, function(obj){
        this.stateService.updateSm(obj.sm);
        this.alertService.alertSuccess("SM cadastrada com sucesso, clique em PROSSEGUIR!", null);
        this.spinnerService.requestEnded();
        if (this.scheduler) {
          clearInterval(this.scheduler);
        }
      }.bind(this));
    }, Utilitarios.WAIT_TIME);
  }

  existeSM(callBack1: any, callBack2: any){
    this.preCheckoutService.getViagemByCpfOrigem(this.cpf, this.values.cdOrigem, this.values.rota)
    .subscribe(
      (result) => {
        if(result.data_inicio){
          this.alertService.alertWarning("Viagem em trânsito, não e permitido realizar o pré-checkout, favor contactar o Glog!", null);
        }
        else if(!result.cpf || (result.cpf != this.cpf)){
          if(callBack1)
            callBack1();
        }
        else{
          if(callBack2)
            callBack2(result);
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar recuperar viagem, tente novamente!");
      }
    );
  }

  proximo(){
    this.stateService.updateTransporterType(this.itemSelected.name);
    this.stateService.updateDestinoCd(this.itemSelectedDestino.name);
    this.stateService.updateTransporter(this.itemSelectedTransportadora.name);
    this.showPlacas = true;
    this.showInfo = false;
  }

  populaTiposTransporte(){
    if(this.rota){
      this.tiposTransporte = [
        {id: 1,name: "Outbound (Entrega em lojas ou transferência entre CDs)"}
      ]

      //Define como default o item
      this.itemSelected = this.tiposTransporte[0];
    }
    else{
      this.tiposTransporte = [
        {id: 2,name: "Inbound (Coleta de mercadorias)"},
        {id: 3,name: "Reversa (Equipamentos e pallets)"},
        {id: 4,name: "EED (Entrega em domicilio"}
      ]
    }
  }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();
    
    this.translate.get("preCheckout").subscribe((res) => {
      this.translation = res;
    });

    this.viagemService.getValues().subscribe((result)=>{
      this.values = result
    });

    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.cpf = cpf;
    });

    this.preCheckoutQuery.name$.subscribe((nome)=>{
      this.nome = nome;
    });

    this.preCheckoutQuery.phone$.subscribe((celular)=>{
      this.celular = celular;
    });

    this.preCheckoutQuery.route$.subscribe((rota)=>{
      this.rota = rota;
    });

    this.preCheckoutQuery.originCd$.subscribe((cdOrigem)=>{
      this.cdOrigemDescricao = cdOrigem;
    });

    this.populaTiposTransporte();
    this.populaCdsDestino();
  }

  internalError(err){
    this.alertService.alertDanger(err || this.translation.internalError, null);
  }

  defineAlertMessages(message, title, classAlert, showAlert: boolean = true){
    this.tentativa = this.alertService.defineAlertMessage(message, title, classAlert, showAlert, this.tentativa);
  }

  prosseguir(){
    this.existeSM(function(){
      this.defineAlertMessages("Não foi localizada nenhuma SM com os dados fornecidos, tente novamente!", null, "alert-warning");
    }.bind(this), function(){
      //Limpa alert
      this.alertService.limpaAlertMessage();
      //Marca como concluído o estágio de viagem
      this.stateService.updateStageViagem(true);
      
      Utilitarios.NEXT_LEVEL="veiculo";
      this.router.navigate(['/veiculo']);
    }.bind(this));
  }
}